export default {
    cptDataForm: {
        dataText: '{"value":"重要通知：xx66666666666666"}',
        dataSource: 1, pollTime: 0
    },
    attribute: {
        textColor: '#fff', fontSize: 18, step: 2, scrollType: 1,
        cptTableData:[{"name":"值","value":"","namekey":"value"}]
    },
}